import clsx from 'clsx';
import { FC } from 'react';
import { HeaderProps } from 'react-table';
import { PostTagDto } from '../model/types';

type Props = {
	className?: string;
	title?: string;
	// Изменяем структуру пропсов: принимаем саму колонку
	column: HeaderProps<PostTagDto>['column'];
};

const TagCustomHeader: FC<Props> = ({ className, title, column }) => {
	// Добавляем проверку (защита от undefined)
	if (!column) return <th className={clsx(className)}>{title}</th>;

	return (
		<th {...column.getHeaderProps()} className={clsx(className)}>
			{title}
		</th>
	);
};

export { TagCustomHeader };
